import { render, staticRenderFns } from "./DealerLookup.vue?vue&type=template&id=fb889fac&scoped=true"
import script from "./DealerLookup.vue?vue&type=script&lang=js"
export * from "./DealerLookup.vue?vue&type=script&lang=js"
import style0 from "./DealerLookup.vue?vue&type=style&index=0&id=fb889fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb889fac",
  null
  
)

export default component.exports